module.exports = __webpack_public_path__ + "img/neighbor-8-image.c1cefe45.svg";